import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

const NavSlider = ({ images, mainSliderRef, navSliderRef }) => {
  const [filteredImages, setFilteredImages] = useState([]);

  const settings = {
    asNavFor: mainSliderRef.current,
    infinite:false,
    dots: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
  };

  useEffect(() => {
    const jpgImages = images.filter((image) => image.toLowerCase().endsWith('.jpg'));
    if (jpgImages.length > 0) {
      setFilteredImages(jpgImages);
    } else {
      setFilteredImages(images.filter((image) => image.toLowerCase().endsWith('.png')));
    }
  }, [images]);

  return (
    <Slider {...settings} ref={navSliderRef}>
      {filteredImages.map((image, index) => (
        <div className="images p-3" key={index}>
          <img
            alt={`Thumbnail ${index}`}
            src={image.includes('https') ? image : `https://onepas.de/v3/msmedia/${image}`}
            className="small-image"
          />
        </div>
      ))}
    </Slider>
  );
};

NavSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  mainSliderRef: PropTypes.object.isRequired,
  navSliderRef: PropTypes.object.isRequired,
};

NavSlider.defaultProps = {
  images: [],
};

export default NavSlider;